export const APIV1 = '/api/v1/';
export const APIV4 = '/api/v4/public/';
